// @flow
import createHttpClient from '../httpClient';
import { logout, getSessionId } from '../auth';
import { createAPIEndpoints as leaguesDraftUtil } from './leagueDraft';
import { createAPIEndpoints as checksumsUtil } from './checksums';
import { createAPIEndpoints as teamDraftUtil } from './teamDraft';
import { createAPIEndpoints as playersUtil } from './players';
import { createAPIEndpoints as roundsUtil } from './rounds';
import { createAPIEndpoints as squadsUtil } from './squads';
import { createAPIEndpoints as venuesUtil } from './venues';

const apiClient = createHttpClient({
	baseApiUrl: process.env.REACT_APP_API_URL,
	baseJSONUrl: process.env.REACT_APP_JSON_URL,
	getSessionId,
	logout,
});

export const Api = {
	leaguesDraft: leaguesDraftUtil(apiClient),
	rounds: roundsUtil(apiClient),
	players: playersUtil(apiClient),
	squads: squadsUtil(apiClient),
	venues: venuesUtil(apiClient),
	checksums: checksumsUtil(apiClient),
	teamsDraft: teamDraftUtil(apiClient),
	// TODO:: Move endpoints below into TDS Draft Utils repo
	Auth: {
		login: (param: any) => apiClient.Public.post("auth/login", param),
		logout: () => apiClient.Private.get("auth/logout"),
		loginSSO: (param: any) => apiClient.Public.post("nrlaccount/auth_code", param)
	},
	User: {
		get: () => apiClient.Private.get("user")
	},
	Notifications: {
		notifications_draft: (param: any) => apiClient.Private.get('notifications_draft', param),
		notification_bar: () => apiClient.JSON.get("/notification-bar-draft.json"),
	}
};

export default Api;


// WEBPACK FOOTER //
// ./src/utils/api/index.js